<form class="layout-form" [formGroup]="documentForm" (ngSubmit)="onSubmit()">
  <div class="component-content">
    <div class="form-header" [ngClass]="{ 'shadow-top': shadowScroll.showShadowTop }">
      <p>Carga de respaldos</p>
      <span> Complete el formulario </span>
    </div>
    <div class="scroll-display" (scroll)="onScroll($event)">
      <div class="form-select-content">
        <div *ngFor="let file of files; let i = index">
          <app-file-upload-component
            [labelText]="file.label"
            [required]="file.required"
            [submitted]="submitted"
            [oneFile]="file.oneFile"
            [documentId]="file.documentId"
            [isImg]="file.isImg"
            [ocrValidation]="file.ocrValidation"
            [extensions]="file.extensions"
            [formControlName]="file.key"
            [maxSizeFile]="file.size"
            [id]="'file' + i"
          ></app-file-upload-component>
          <div *ngIf="i == 1 && ocrError">
            <label class="warning-label">
              No fue posible validar el DNI. Por favor, adjunte nuevamente la imagen del dorso</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-navigation" [ngClass]="{ 'shadow-bottom': shadowScroll.showShadowBottom }">
    <app-navigation [currentStep]="5" [countSteppers]="7"></app-navigation>
  </div>
  <div class="button-container">
    <button mat-raised-button class="back-button" type="button" (click)="back()">Anterior</button>
    <button mat-raised-button class="next-button next-button__60" type="submit">Siguiente</button>
  </div>
</form>
